// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"az_mbb","azLogo":"az_nbb","azLogoMedium":"az_obb"};